<template>
    <div class="">
        <div class="d-flex">
            <template v-if="percentual > 50">
                <div :style="{width: percentual+'%'}" :class="'txt-end pe-1 txt-p txt-size-9 txt-w-5 txt-'+getColor()">
                    <span>
                        {{percentual}}%
                    </span>
                </div>
            </template>
            <template v-else>
                <div :style="{width: percentual+'%'}" :class="'txt-end txt-p txt-size-9 txt-w-5 txt-'+getColor()">
                   
                </div>
                <div :class="'txt-p txt-size-9 txt-w-5 txt-'+getColor()">
                    <span>
                        {{percentual}}%
                    </span>
                </div>
            </template>
            
        </div>
        
        <div class="progress" style="">
            <div :class="'progress-bar bg-'+getColor()" role="progressbar" :style="{width: percentual+'%'}" :aria-valuenow="percentual" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
    
</template>

<script>
    export default {
        name: 'ProgressAula',
        props: {
            percentual: Number,
        },
        data: function () {
            return {
            }
        },
        methods: {
            getColor() {
                if (this.percentual == 0) {
                    return 'grey';
                } else if (this.percentual <= 25) {
                    return 'red';
                } else if (this.percentual <= 50) {
                    return 'yellow';
                } else {
                    return 'green';
                }
            },
        },
        created: function () {
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .progress {
        height: 10px;
        border-radius: initial;
    }

    .bg-grey {
        background-color: #C4C4C4;
    }

    .txt-grey {
        color: #C4C4C4;
    }

    .bg-red {
        background-color: #FF4D00;
    }

    .txt-red {
        color: #FF4D00;
    }

    .bg-yellow {
        background-color: #F0C964;
    }

    .txt-yellow {
        color: #F0C964;
    }

    .bg-green {
        background-color: #8F9D38;
    }

    .txt-green {
        color: #8F9D38;
    }

</style>

